import React from 'react';
import { Alert, Box, Chip, CircularProgress, Typography } from '@mui/material';
import ProfilePermissionsEditor from './permissions/ProfilePermissionsEditor.jsx';
import BusinessFunctionsPermissionSection from './permissions/BusinessFunctionsPermissionSection.jsx';
import useProfileSx from '../hooks/useProfileSx.js';
import { PROFILE_CLONE_COPY } from '../utils/profileConstants.js';

export default function ProfileClonePreviewPanel({
  catalog,
  grants,
  resourceTree,
  businessFunctionsSection,
  hasPermissionsContent,
  isLoading,
  error,
  isDirty = false,
  disabled = false,
  onNodeGrantChange,
  onFeatureChange,
  onObjectChange,
  onGrantsPatch,
}) {
  const styles = useProfileSx();

  return (
    <Box sx={styles.clonePreviewSection}>
      <Box sx={styles.clonePreviewHeader}>
        <Box sx={styles.clonePreviewTitleRow}>
          <Typography sx={styles.clonePreviewTitle}>
            {PROFILE_CLONE_COPY.permissionsTitle}
          </Typography>
          {isDirty ? (
            <Chip
              label={PROFILE_CLONE_COPY.modifiedLabel}
              size="small"
              color="primary"
              variant="outlined"
            />
          ) : null}
        </Box>
        <Typography sx={styles.clonePreviewDescription}>
          {PROFILE_CLONE_COPY.permissionsDescription}
        </Typography>
      </Box>

      {isLoading ? (
        <Box sx={styles.clonePreviewLoading}>
          <CircularProgress size={22} />
          <Typography variant="body2" color="text.secondary">
            {PROFILE_CLONE_COPY.permissionsLoading}
          </Typography>
        </Box>
      ) : null}

      {!isLoading && error ? (
        <Alert severity="warning" sx={styles.clonePreviewAlert}>
          {PROFILE_CLONE_COPY.permissionsError}
        </Alert>
      ) : null}

      {!isLoading && !error && !hasPermissionsContent ? (
        <Typography sx={styles.clonePreviewDescription}>
          {PROFILE_CLONE_COPY.permissionsEmpty}
        </Typography>
      ) : null}

      {!isLoading && !error && hasPermissionsContent ? (
        <Box sx={styles.clonePreviewScroll}>
          <ProfilePermissionsEditor
            catalog={catalog}
            grants={grants}
            disabled={disabled}
            onNodeGrantChange={onNodeGrantChange}
            onFeatureChange={onFeatureChange}
            onObjectChange={onObjectChange}
          />
          {businessFunctionsSection ? (
            <BusinessFunctionsPermissionSection
              section={businessFunctionsSection}
              grants={grants}
              resourceTree={resourceTree}
              isResourceTreeLoading={false}
              disabled={disabled}
              onGrantsPatch={onGrantsPatch}
            />
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
}
